// extracted by mini-css-extract-plugin
export var notificationHost = "_cc-0";